import React from 'react';
import { View, StyleSheet } from 'react-native';
import Skeleton from './Skeleton';

const DashboardSkeleton: React.FC = () => {
  return (
    <View style={styles.container}>
      {/* Ledger Summary Card Skeleton */}
      <View style={styles.card}>
        <Skeleton width={120} height={20} borderRadius={4} style={{ marginBottom: 16 }} />
        <View style={styles.statsRow}>
          <View style={styles.statItem}>
            <Skeleton width={60} height={14} borderRadius={4} />
            <Skeleton width={80} height={24} borderRadius={4} style={{ marginTop: 8 }} />
          </View>
          <View style={styles.statItem}>
            <Skeleton width={60} height={14} borderRadius={4} />
            <Skeleton width={80} height={24} borderRadius={4} style={{ marginTop: 8 }} />
          </View>
        </View>
        <View style={styles.divider} />
        <View style={styles.balanceRow}>
          <Skeleton width={100} height={16} borderRadius={4} />
          <Skeleton width={120} height={28} borderRadius={4} />
        </View>
      </View>

      {/* Business Card Skeleton */}
      <View style={[styles.card, styles.businessCard]}>
        <View style={styles.businessHeader}>
          <Skeleton width={60} height={60} borderRadius={30} />
          <View style={{ marginLeft: 16, flex: 1 }}>
            <Skeleton width="70%" height={20} borderRadius={4} />
            <Skeleton width="50%" height={14} borderRadius={4} style={{ marginTop: 8 }} />
          </View>
        </View>
        <Skeleton width="100%" height={1} borderRadius={0} style={{ marginVertical: 16 }} />
        <View style={styles.businessInfo}>
          <Skeleton width="40%" height={14} borderRadius={4} />
          <Skeleton width="60%" height={14} borderRadius={4} style={{ marginTop: 8 }} />
          <Skeleton width="50%" height={14} borderRadius={4} style={{ marginTop: 8 }} />
        </View>
      </View>

      {/* Work Summary Card Skeleton */}
      <View style={styles.card}>
        <Skeleton width={100} height={20} borderRadius={4} style={{ marginBottom: 16 }} />
        <View style={styles.workStats}>
          <View style={styles.workStatItem}>
            <Skeleton width={40} height={40} borderRadius={20} />
            <Skeleton width={60} height={14} borderRadius={4} style={{ marginTop: 8 }} />
          </View>
          <View style={styles.workStatItem}>
            <Skeleton width={40} height={40} borderRadius={20} />
            <Skeleton width={60} height={14} borderRadius={4} style={{ marginTop: 8 }} />
          </View>
          <View style={styles.workStatItem}>
            <Skeleton width={40} height={40} borderRadius={20} />
            <Skeleton width={60} height={14} borderRadius={4} style={{ marginTop: 8 }} />
          </View>
        </View>
      </View>

      {/* Network Summary Card Skeleton */}
      <View style={styles.card}>
        <Skeleton width={120} height={20} borderRadius={4} style={{ marginBottom: 16 }} />
        <View style={styles.networkRow}>
          <Skeleton width={80} height={50} borderRadius={8} />
          <Skeleton width={80} height={50} borderRadius={8} />
          <Skeleton width={80} height={50} borderRadius={8} />
        </View>
      </View>

      {/* Clubs Shortcut Card Skeleton */}
      <View style={styles.card}>
        <Skeleton width={100} height={20} borderRadius={4} style={{ marginBottom: 16 }} />
        <Skeleton width="100%" height={60} borderRadius={12} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
  },
  card: {
    padding: 16,
    borderRadius: 12,
    marginBottom: 16,
  },
  businessCard: {
    padding: 24,
  },
  statsRow: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginBottom: 16,
  },
  statItem: {
    alignItems: 'center',
  },
  divider: {
    height: 1,
    marginVertical: 16,
  },
  balanceRow: {
    alignItems: 'center',
    gap: 8,
  },
  businessHeader: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  businessInfo: {
    gap: 8,
  },
  workStats: {
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  workStatItem: {
    alignItems: 'center',
  },
  networkRow: {
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
});

export default DashboardSkeleton;
